import { useCallback, useEffect, useState } from "react"

// Despite the legacy name, this hook no longer debounces; the search is now
// committed on demand (e.g. when the user presses Enter) so the consumer must
// invoke `submitSearch` explicitly. The signature stays backwards-compatible:
// `[searchTemp, setSearchTemp]` continues to work, with `submitSearch` exposed
// as a third array element for callers that need it.
export default function useDebouncedSearchParam({
  search,
  searchParams,
  setSearchParams,
  // delay is kept in the API for backwards compatibility but is now ignored.
  delay: _delay,
}) {
  const [searchTemp, setSearchTemp] = useState(search ?? "")

  useEffect(() => {
    setSearchTemp(search ?? "")
  }, [search])

  const submitSearch = useCallback(() => {
    const normalizedSearch = String(searchTemp ?? "")
    const currentSearch = String(search ?? "")

    if (normalizedSearch === currentSearch) {
      return
    }

    const nextParams = new URLSearchParams(searchParams)

    if (normalizedSearch.trim()) {
      nextParams.set("search", normalizedSearch)
    } else {
      nextParams.delete("search")
    }

    nextParams.delete("page")

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams)
    }
  }, [search, searchParams, searchTemp, setSearchParams])

  return [searchTemp, setSearchTemp, submitSearch]
}
